import React from 'react';
import { StyleSheet, View } from 'react-native';
import {
  me_txt,
  userInitialsNameCB,
  userInitialsNameDK,
  userInitialsNameSD,
  userNameCB,
  userNameDK,
  userNameSD,
} from '../../utils/DictionaryManagementUtils';
import Avatar from './Avatar';

const ContactFloatBubble = ({
  globJSON,
  simPlatform,
}) => {
  const { colors } = globJSON.configurations.theme;
  const avatarColor = colors.primary_cta_color;
  return (
    <View style={styles.frame}>
      <Avatar
        globJSON={globJSON}
        simPlatform={simPlatform}
        fullNameText={me_txt}
        txtInitials={me_txt}
        the_avatar_bg_color={avatarColor}
        the_avatar_fn_color={colors.cta_font_color}
        style={styles.avatarSpace}
        withExitButton
      />

      <Avatar
        globJSON={globJSON}
        simPlatform={simPlatform}
        fullNameText={userNameSD}
        txtInitials={userInitialsNameSD}
        the_avatar_bg_color={avatarColor}
        the_avatar_fn_color={colors.cta_font_color}
        style={styles.avatarSpace}
        withExitButton
      />

      <Avatar
        globJSON={globJSON}
        simPlatform={simPlatform}
        fullNameText={userNameDK}
        txtInitials={userInitialsNameDK}
        the_avatar_bg_color={avatarColor}
        the_avatar_fn_color={colors.cta_font_color}
        style={styles.avatarSpace}
        withExitButton
      />

      <Avatar
        globJSON={globJSON}
        simPlatform={simPlatform}
        fullNameText={me_txt}
        txtInitials={me_txt}
        the_avatar_bg_color={avatarColor}
        the_avatar_fn_color={colors.cta_font_color}
        style={styles.avatarSpace}
        withExitButton
      />

      <Avatar
        globJSON={globJSON}
        simPlatform={simPlatform}
        fullNameText={userNameCB}
        txtInitials={userInitialsNameCB}
        the_avatar_bg_color={avatarColor}
        the_avatar_fn_color={colors.cta_font_color}
        style={styles.avatarSpace}
        withExitButton
      />

      <Avatar
        globJSON={globJSON}
        simPlatform={simPlatform}
        fullNameText={userNameDK}
        txtInitials={userInitialsNameDK}
        the_avatar_bg_color={avatarColor}
        the_avatar_fn_color={colors.cta_font_color}
        style={styles.avatarSpace}
        withExitButton
      />
    </View>
  );
};

const styles = StyleSheet.create({
  frame: {
    padding: 10,
    flexDirection: 'row',
  },
  avatarSpace: {
    marginEnd: 7,
    marginStart: 7,
  },
});
export default ContactFloatBubble;
